import PropTypes from 'prop-types'
import React, { useContext, useState } from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { LoadingContext, M_StateActions, MTable } from 'src/M_Components'

export default function UserConfig({ roles, onCreateTab, toastMessages }) {
    const ctx = useContext(LoadingContext)
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [refresh, setRefresh] = useState(false)
    const removeContextItems = ['Print', 'Copy']

    //============================================================================================================
    // Helper function to create a new route
    //============================================================================================================
    const NewRoute = (url, label, operation, data) => {
        dispatch(M_StateActions.addM_State({ key: 'operation', value: operation })) // Store the current operation in the state
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') { // Check if the operation is one of the specified types
            if (!data) { // These specified types need User data to render, check if exists
                toastMessages('error', '', t("SelectedLine"))
                return // returns early if no data is provided
            }
            dispatch(M_StateActions.addM_State({ key: 'UserLine', value: data })) // Store the selected user data in the state
        }
        if (operation === 'Create') {
            onCreateTab(url, label)
        }
        else if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            onCreateTab(url, `${label} "${data.FirstName}"`)
        }
    }

    return (
        <div className='divGlobalSettings'>
            <div className='subTitleSettings'>
                <div>
                    <div style={{ color: ctx.secondaryColor }}>
                        {t("Users")}
                    </div>
                    <div className='labelSubtitleSettings'>
                        {t("InfoUsers")}
                    </div>
                </div>
            </div>
            <MTable // Dynamic table with Users
                filtersOnTable
                entityName={'Users'}
                roleName={'Users'}
                rolePermissions={roles}
                removeContextItems={removeContextItems}
                refresh={refresh}
                setRefresh={setRefresh}
                useSessionStorage={false}
                replaceFunctions={new Map([
                    ['View', (e) => NewRoute("UserConfig", t("LabelViewUser"), 'View', e)],
                    ['Create', (e) => NewRoute("UserConfig", t("LabelNewUser"), 'Create', e)],
                    ['Edit', (e) => NewRoute("UserConfig", t("LabelEditUser"), 'Edit', e)],
                ])}
            />
        </div>
    )
}

UserConfig.propTypes = {
    roles: PropTypes.array,
    onCreateTab: PropTypes.func,
    toastMessages: PropTypes.func
}